<div class="card-select">
  <button #trigger type="button" class="card-select-trigger" [class.open]="open" [disabled]="options.length === 0"
    (click)="toggle()">
    <ng-container *ngIf="selected; else placeholderTpl">
      <img *ngIf="selected.imageUrl" class="card-select-trigger-img" [src]="selected.imageUrl" [alt]="selected.label">
      <span class="card-select-trigger-label">{{ selected.label }}</span>
    </ng-container>
    <ng-template #placeholderTpl>
      <span class="card-select-placeholder">{{ placeholder }}</span>
    </ng-template>
    <i class="fal fa-angle-down card-select-chevron" [class.open]="open"></i>
  </button>

  <div class="card-select-panel" *ngIf="open" [ngStyle]="panelStyle">
    <div class="card-select-empty" *ngIf="options.length === 0">{{ emptyMessage }}</div>
    <div class="card-select-option" *ngFor="let option of options; trackBy: trackByOptionId" [class.active]="option.id === value"
      (click)="select(option)">
      <img *ngIf="option.imageUrl" class="card-select-option-img" [src]="option.imageUrl" [alt]="option.label">
      <div class="card-select-option-text">
        <span class="card-select-option-label">{{ option.label }}</span>
        <span class="card-select-option-sublabel" *ngIf="option.sublabel">{{ option.sublabel }}</span>
      </div>
    </div>
  </div>
</div>
